import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    currencies: [],
    loading: false,
    saving: false
};

export default function user(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_CURRENCY:
            newState.loading = true;
            break;

        case actions.SAVING_CURRENCY:
            newState.saving = true;
            break;

        case actions.RECEIVED_CURRENCY:
            newState.currencies = utils.mapById(action.payload);
            newState.loading = false;
            break;

        case actions.SAVED_CURRENCY:
            //let found = false;
            for (let i = 0; i < newState.currencies.length; i++) {
                if(newState.currencies[i].id === action.payload.id){
                    //found = true;
                    newState.currencies[i] = action.payload;
                }
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_CURRENCY:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/currency.js